export const useCases = [
  {
    id: 1,
    icon: "📡",
    category: "Telecoms",
    title: "Hotspot Network Management & Targeted Advertising for a Telco",
    challenge:
      "A South African telecoms operator needed a centralised platform to manage a large estate of Wi-Fi hotspots and unlock revenue from their network. Ad-hoc management across sites was inefficient, and there was no mechanism to monetise the connectivity or serve targeted content to users at the point of login.",
    outcomes: [
      "Konecta\u2019s Wi-Fi management platform deployed to manage hotspot estate at scale",
      "Branded captive portal with targeted advertising served at point of Wi-Fi login",
      "Centralised dashboard giving full visibility and control across all hotspot sites",
      "New revenue stream activated through managed Wi-Fi advertising",
    ],
    service: "Wi-Fi-as-a-Service",
  },
  {
    id: 2,
    icon: "☕",
    category: "Hospitality & Retail",
    title:
      "Real-Time Customer Feedback & Menu Showcase via Wi-Fi Portal for a Coffee Shop Group",
    challenge:
      "A coffee shop group wanted to engage customers at the moment they connected to Wi-Fi \u2014 before they left and posted negative reviews online. They needed a way to showcase their menu, gather real-time feedback, and resolve issues before they became public complaints.",
    outcomes: [
      "Custom branded captive portal displaying menu, daily specials, and promotions on login",
      "Real-time customer feedback survey integrated into the Wi-Fi login experience",
      "Issues captured and flagged to management before customers leave the venue",
      "Measurable reduction in negative online reviews through in-venue resolution",
    ],
    service: "Wi-Fi-as-a-Service",
  },
  {
    id: 3,
    icon: "🌍",
    category: "World Bank \u2014 Thembisa",
    title: "World Bank Thembisa Community Wi-Fi Project",
    challenge:
      "As part of a World Bank-supported initiative, Konecta was engaged to design and deploy community Wi-Fi infrastructure in Thembisa \u2014 one of Gauteng\u2019s largest townships. The mandate was to deliver reliable, managed connectivity to an underserved community and enable meaningful digital access at scale.",
    outcomes: [
      "Community Wi-Fi hotspot infrastructure designed and deployed across Thembisa",
      "Managed network with centralised monitoring ensuring sustained uptime and service quality",
      "Digital access delivered to residents previously without reliable connectivity",
      "Delivered in partnership with the World Bank Group \u2014 IBRD \u2014 IDA",
    ],
    service: "Wi-Fi-as-a-Service \u2014 Managed IT Services",
  },
  {
    id: 4,
    icon: "🚕",
    category: "Public Infrastructure \u2014 Alexandra",
    title: "Alexandra Taxi Rank Wi-Fi Hotspot Deployment",
    challenge:
      "The Alexandra taxi rank serves thousands of daily commuters moving through one of Johannesburg\u2019s most active transport hubs. There was no managed Wi-Fi infrastructure in place \u2014 leaving a high-footfall public space without connectivity and a large captive audience unserved.",
    outcomes: [
      "Wi-Fi hotspot infrastructure deployed and commissioned at Alexandra taxi rank",
      "Branded captive portal providing managed public access to commuters",
      "Network monitoring and management maintained by Konecta post-deployment",
      "Digital connectivity brought to a key public transport hub serving the Alexandra community",
    ],
    service: "Wi-Fi-as-a-Service \u2014 Managed IT Services",
  },
];
